// extracted by mini-css-extract-plugin
module.exports = {"warningBox":"warningBox__3Zf2m","warning":"warning__34foa"};